var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStickFourthpageBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1165,
    height: 1298,
    viewBox: "0 0 1165 1298",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_4498_1200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M276.046 799.612C18.6586 1002.53 340.679 1086.36 533.863 1102.91C1278.81 1196.33 1419.52 822.751 1216.04 630.675C1012.57 438.6 1225.79 271.304 1147.81 199.192C1069.83 127.08 816.866 274.839 786.174 461.615C755.482 648.39 597.78 545.97 276.046 799.612Z",
    fill: "url(#paint0_angular_4498_1200)",
    fillOpacity: 0.32
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4498_1200",
    x: 0.308594,
    y: 0.5625,
    width: 1480.16,
    height: 1297.1,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 90,
    result: "effect1_foregroundBlur_4498_1200"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_4498_1200",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(710.257 725.644) rotate(42.9867) scale(394.015 475.322)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDD795"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#EE717C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C09DD6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickFourthpageBg);
export default __webpack_public_path__ + "static/media/stick-fourthpage-bg.d25024ee61157952409a9b54e407e65d.svg";
export { ForwardRef as ReactComponent };